// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { check16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-check': IconCheck;
    }
}

/**
 * The icon component for the 'check' icon
 */
export class IconCheck extends IconSvg {
    public constructor() {
        super(check16X16);
    }
}

registerIconSvg('icon-check', IconCheck);
export const iconCheckTag = 'nimble-icon-check';
